import sendErrMsg from "@/utils/sendErrMsg";
import { Button } from "antd-mobile";
export default function ErrorPage(props: any) {
  const errorMessage = props.errorMessage;
  const refreshPage = props.refreshPage;
  const { $t } = useTranslate();
  useEffect(() => {
    sendErrMsg();
  }, []);
  return (
    <div className="bg-[var(--app-bg-06)] w-full h-100dvh fixed top-50% left-50% translate-[-50%] center flex-col gap-y-20 z-999">
      <div className="text-16 flex items-center font-weight-lighter gap-6 color-[var(--app-text-11)]">{errorMessage}</div>
      <Button color="primary" fill="solid" size="small" onClick={() => refreshPage && refreshPage()}>
        {$t("title55")}
      </Button>
    </div>
  );
}
